import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ArticleCards from "./components/ArticleCards";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ArticleCards />
        <Testimonials />
        <FAQ />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}